import Icon from '@material-ui/icons/People';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { Filter, ResourceList } from '../../../controllers';
import { DateTimeField, LinkField } from '../../../fields';
import { BooleanInput, NestedReferenceInput, StreamSelectInput } from '../../../inputs';



export default {
  Icon,
  dialogs: {
    create: props => (
      <CreateButton
        {...props}
        fixedValue={{ organization_id: props.parentResource.id }}
      >
        <StreamSelectInput />
        <NestedReferenceInput
          label="Registrant"
          reference="users"
          resourcePath={`/organizations/${props.parentResource.id}`}
          source="registrant_id"
          required
        />
        
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <DateTimeField
          source="created_at"
        />

        <LinkField
          displaySource="title"
          reference="streaming_streams"
          source="stream_id"
        />

        <LinkField
          reference="users"
          source="registrant_id"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
